import moment from "moment";
import { RegistrationEnums } from "../types/ApplicationTypes";

export const handleGetDateOfBirth = (dateField: string | moment.Moment) => {
  let dob: moment.Moment | string;
  if (dateField !== "" && dateField !== null && dateField) {
    dob = moment(dateField).format("YYYY-MM-DD");
  } else {
    dob = RegistrationEnums.DateOfBirth;
  }
  return dob;
};
